module.exports = __webpack_public_path__ + "static/media/centralised-timesheets.80c433ff.png";